import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-71-small', 'Number71Small', [["path",{"d":"M15 8h1v8"}],["path",{"d":"M7 8h4l-2 8"}]]);